define(['ko', '_'], function (ko, _) {
    return function (category, level) {
        var self = this;
        self.id = category.id;
        self.name = category.name;
        self.parent = category.parent;
        self.count = ko.observable(category.count);
        self.slug = category.slug;
        self.level = level;
        
        self.open = ko.observable(false);
        self.toggleState = function() {
            self.open(!self.open());
        }

        self.categories = category.categories;
        if(category.checked !== undefined) {
            self.checked = ko.observable(category.checked);
        } else {
            self.checked = ko.observable(false);
        }
    };
});
